import { render, staticRenderFns } from "./ArchiveIndex.vue?vue&type=template&id=0ab877af&"
import script from "./ArchiveIndex.vue?vue&type=script&lang=js&"
export * from "./ArchiveIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports